import { StreamActions } from '@hotwired/turbo'

// <turbo-stream action="visit" url="…">: полный переход на страницу.
//
// Нужен формам в модалках с data-turbo: при ошибке сервер перерисовывает
// форму turbo-stream-ом, а при успехе должна загрузиться обновлённая
// страница. Обычный редирект после Turbo-сабмита тут не годится: у body
// сайта data-turbo="false", и Turbo дописывал новую страницу к старой
// (секция задваивалась, модалка оставалась висеть поверх).
//
// Адрес, который отличается от текущего только якорем (запись со страницы
// тренера возвращает на «…/coaches/имя#schedule»), assign не загружает, а
// лишь прокручивает: окно осталось бы открытым, а сообщение из flash не
// показалось бы. Тогда меняем адрес и перезагружаем страницу.
StreamActions.visit = function visit() {
  const url = this.getAttribute('url')
  if (!url) return

  const target = new URL(url, window.location.href)
  const here = window.location
  const sameDocument =
    target.origin === here.origin &&
    target.pathname === here.pathname &&
    target.search === here.search

  if (sameDocument && target.hash) {
    window.history.replaceState(window.history.state, '', target.href)
    window.location.reload()
  } else {
    window.location.assign(target.href)
  }
}
